(function ($, window) {
    let prodigy_product_bulk = {
        enable_bulk_element: '.enable-bulk-js',
        add_to_cart_button: "button.add-to-cart-js",
        bulk_container_general: '.bulk-container-js',
        bulk_container: '.bulk-container-',
        variant_container: '.variant-container-',
        swatch_variant_container: '.swatch-variant-container-',
        button_disable_bulk: '.disable-bulk-button-js',
        link_disable_bulk: '.disable-bulk-js',
        bulk_modal: '#disableBulkModal',
        counter_element: '.prodigy-counter-wrap-js',
        bulk_total_block: '.bulk-total-block-js',
        close_bulk_modal: '.close-bulk-modal-js',
        replaced_hidden_option: '',
        disable_bulk_modal_text: '.disable-bulk-modal-text-js',
        disable_bulk_link_element: '.disable-bulk-link-js',
        is_active_logo_bulk: false,
        is_active_bulk: false,
        bulk_container_element: '.bulk-container-js',
        input_bulk_quantity_element: '.prodigy-bulk-input-js',
        bulk_price_modifier_element: '.bulk-price-modify-js',
        bulk_stock_status: '.stock-indicator-label-js',
        bulk_stock_qty: '.stock-indicator-qty-js',
        bulkVariants: [],
        bulkTotalQuantity: 0,
        bulk_total_price: '.bulk-total-price-js',
        _stock_status_mapper: {"in_stock": "In stock", "out_of_stock": "Out of stock"},
        total_quantity_element: '.prodigy-bulk-total-qty-js',

        init: function () {
            if (this.is_bulk()) {
                this.set_quantity_validation();
            }
            this.bulk_showing_manager();
        },

        reset_bulk_inputs: function (is_required_location=null,except_option=null) {
            $(prodigyProductBulk.input_bulk_quantity_element).each(function () {
				if ($(this).data('option') !== except_option) {
					$(this).val('');
				}
            });
			if (!is_required_location) {
				$(this.total_quantity_element).text(0);
				$(this.bulk_total_price).text('$0.00');
			}
        },

        update_bulk_price: function (data) {
            let total_price = 0;
            if (data && typeof data.result !== "undefined") {
                for (let key in data.result) {
                    let product_quantity = data.result[key].number_of_items;
                    if (typeof data.result[key].attributes !== "undefined") {
                        let price = data.result[key].attributes.price;
                        let sale_price = data.result[key].attributes['sale-price'];
                        let tiered_price = data.result[key].attributes.tiered_price;
                        if (product_quantity === 0) {
                            this.reset_bulk_inputs();
                            return;
                        }

                        total_price += prodigyProduct.calculate_product_price(price, tiered_price, product_quantity, false);
                    }
                }
            }

            if (typeof data !== "undefined") {
                if (product_logo_management_object.is_logo()) {
                    total_price += parseFloat($('#product-setup-charge-js').val()) || 0;
                }
                $(this.bulk_total_price).text('$' + prodigy_price_format(total_price));
                $('.product-default-info-price-js').text('$' + total_price);
            }
        },

        is_bulk: function () {
            return $(this.enable_bulk_element).is(":visible");
        },

        is_bulk_enabled: function () {
            return $(this.bulk_container_general).is(":visible");
        },

        get_attr_name_with_bulk_enabled() {
            return $(this.bulk_container_general + ':visible').data('attribute');
        },

		open_bulk_options_mode: function (container) {
			let self = this;
			self.is_active_bulk = true;
			let attribute_name = container.data('attribute');

			if (typeof attribute_name === "undefined") {
				attribute_name = $('.bulk-container-js:visible').data('attribute');
			}
			self.set_ignored_class_for_bulk_option(attribute_name);
			prodigyProduct.set_variant_modifier(attribute_name);

			if (self.is_active_bulk) {
                $('.prodigy-product__main-variant-price-js').hide();
                $('.prodigy-product__main-price-range-js').show();
                $('.prodigy-product__main-price').hide();

				prodigyProduct.show_available_variants_bulk(attribute_name);
				$(self.button_disable_bulk).data('attribute', self.get_attr_name_with_bulk_enabled());
				$(self.button_disable_bulk).data('show-attribute', attribute_name);
				$(self.disable_bulk_modal_text).text('Disable Multiple Quantity for ' + self.get_attr_name_with_bulk_enabled());
				if (attribute_name === product_logo_management_object.logo_attribute) {
					self.is_active_logo_bulk = true;
                    $(document).trigger('enable-multiple-quantity', container);
				}
                self.hide_default_product_info();
			}

			if (self.is_bulk_enabled()) {
				$(self.bulk_modal).modal('show');

				return;
			}

			self.show_bulk_for_attr(attribute_name);
		},

		set_all_locations: function () {
			$('.prodigy-logo-tool__container.opened .prodigy-logo-location-js').each(function () {
				const $location_select = $(this);
				const location_id = $(this).val();
				const $location_option = $location_select.find('option[value="' + location_id + '"]');
				$location_option.prop('disabled', false);
				$location_select.closest('.prodigy-product-location-block-js').removeClass('prodigy-product__logo-location--required');
			});
		},

		set_not_required_locations: function () {
			$('.prodigy-logo-tool__container.opened .prodigy-logo-location-js').each(function () {
				const $location_select = $(this);
				const location_id = $(this).val();
				const $location_option = $location_select.find('option[value="' + location_id + '"]');
				const is_required = $location_option.data('required');
				if (is_required) {
					product_logo_management_object.disable_required_selected_location(location_id);
				}
			});
		},

        set_ignored_class_for_bulk_option: function (attribute_name) {
            $('.attribute_values_js[data-attribute="' + attribute_name + '"]').addClass('ignored');
            $('.prodigy-product__swatch-block-js[data-attribute="' + attribute_name + '"]').addClass('ignored');
        },

        return_product_state: function () {
            $('.prodigy-product__main-price').show();
            $('.prodigy-product__prop-text').show();
            $('.main-price-currency-js').hide();
            $('.prodigy-product-stock-js').show();
            $('.prodigy-product__prop-wrap').show();
        },

        bulk_showing_manager: function () {
            let self = this;
            $(this.enable_bulk_element).on('click', function () {
                self.open_bulk_options_mode($(this));
            });

            $(this.close_bulk_modal).on('click', function () {
                $(self.bulk_modal).modal('hide');
            });

            $(this.disable_bulk_link_element).on('click', function () {
                self.close_bulk_mode($(this));
            });

            $(this.link_disable_bulk).on('click', function () {
                let attribute_name = $(this).data('attribute');

                if (self.is_active_bulk) {
                    prodigyProduct.show_available_variants_bulk(attribute_name);
                }

                $(self.button_disable_bulk).data('attribute', attribute_name);
                $(self.disable_bulk_modal_text).text('Enable Multiple Quantity for ' + attribute_name);
                $(self.bulk_modal).modal('show');
            });


            $(this.button_disable_bulk).on('click', function () {
                let attribute_name = $(this).data('attribute');
                $(self.bulk_modal).modal('hide');
                self.hide_bulk_for_attr(attribute_name);
                self.show_bulk_for_attr($(this).data('show-attribute'));
                $(this).removeData('attribute');
                $(this).removeData('show-attribute');
                self.show_price_bulk_block();
                self.reset_bulk_inputs();
                $('.attribute_values_js[data-attribute="' + attribute_name + '"]').removeClass('ignored');
                $('.prodigy-product__swatch-block-js[data-attribute="' + attribute_name + '"]').removeClass('ignored');
                $(document).trigger('enable-multiple-quantity', [this]);

                if (prodigyProduct.is_bulk()) {
                    let bulk_attribute = $('.bulk-container-js:visible').data('attribute');
                    prodigyProduct.set_variant_modifier(bulk_attribute);
                }
            });
        },

        close_bulk_mode: function (container) {
            let self = this;
            self.is_active_bulk = false;
            let attribute_name = container.data('attribute');
            if (product_logo_management_object.is_logo()) {
                self.is_active_logo_bulk = false;
                self.return_product_state();
            }
            $('.bulk-container-' + attribute_name + '-js').hide();
            $(self.variant_container + attribute_name + '-js').show();
            $('.disable-bulk-link-js[data-attribute="' + attribute_name + '"]').hide();
            $('.enable-bulk-js[data-attribute="' + attribute_name + '"]').show();
			$('.attribute_values_js[data-attribute="' + attribute_name + '"]').removeClass('ignored');
			$('.prodigy-product__swatch-block-js[data-attribute="' + attribute_name + '"]').removeClass('ignored');

			self.show_price_bulk_block();
            self.show_default_product_info();
			if (prodigyProduct.is_swatches()) {
				prodigyProduct.set_checked_swatch();
			} else {
				prodigyProduct.set_attribute_value_options();
			}

			if (self.is_active_bulk) {
				prodigyProduct.show_available_variants_bulk(attribute_name);
			} else {
				prodigyProduct.set_variant_data();
			}
			prodigyProduct.show_available_variants();
			self.reset_bulk_inputs();
			if (typeof product_logo_management_object !== 'undefined' && product_logo_management_object.is_logo()) {
				$(document).trigger('enable-multiple-quantity', [container]);
			}
        },

        show_default_product_info: function () {
            $('.prodigy-product__prop-wrap').show();
        },

        hide_default_product_info: function () {
            $('.prodigy-product__prop-wrap').hide();
        },

        hide_bulk_for_attr: function (attribute_name) {
            $(this.bulk_container + attribute_name + '-js').hide();
            $(this.variant_container + attribute_name + '-js').show();
            $('.attribute_values_js[data-attribute="' + attribute_name + '"]').removeClass('ignored');
            $(this.counter_element).show();
            $(this.bulk_total_block).hide();
        },

        show_bulk_for_attr: function (attribute_name) {
            $(this.variant_container + attribute_name + '-js').hide();
            $('.bulk-container-' + attribute_name + '-js').show();
            $('.enable-bulk-js[data-attribute="' + attribute_name + '"]').hide();
            $('.enable-bulk-js[data-attribute="' + attribute_name + '"]').closest('.prodigy-product__attr-text-label');
            $('.attribute_values_js[data-attribute="' + attribute_name + '"]').hide();
            $('.disable-bulk-link-js[data-attribute="' + attribute_name + '"]').show();
            $('.attribute_values_js[data-attribute="' + attribute_name + '"]').addClass('ignored');

            $('.enable-bulk-' + attribute_name + '-js').hide();
            $(this.counter_element).hide();
            $(this.bulk_total_block).show();

            $(this.enable_bulk_element).each(function () {
                if ($(this).data('attribute') !== attribute_name) {
                    $(this).show();
                }
            });

            $(this.disable_bulk_link_element).each(function () {
                if ($(this).data('attribute') !== attribute_name) {
                    $(this).hide();
                }
            });

            if (this.is_active_logo_bulk && typeof product_logo_management_object !== 'undefined' && product_logo_management_object.is_logo()) {
                $(document).trigger('enable-multiple-quantity');
            }
        },

        has_bulk_color_attribute: function () {
            let has_color_attribute = false;
            $(this.enable_bulk_element).each(function () {
                if ($(this).data('attribute') === product_logo_management_object.logo_attribute) {
                    has_color_attribute = true;
                }
            });

            return has_color_attribute;
        },

        show_price_bulk_block: function () {
            let is_show_bulk_price_block = $('.bulk-container-js').is(":visible");
            if (is_show_bulk_price_block) {
                $('.prodigy-counter-wrap-js').hide();
                $('.bulk-total-block-js').show();
            } else {
                $('.bulk-total-block-js').hide();
                $('.prodigy-counter-wrap-js').show();
            }
        },

        set_quantity_validation: function () {
            $(this.input_bulk_quantity_element).inputmask({
                mask: '9{1,4}',
                regex: "^[1-9][0-9]*|$"
            });
        },

        activate_bulk_processes: function () {
            let active_bulk_attribute = $('.bulk-container-js:visible').data('attribute');
            this.set_bulk_data();
            prodigyProduct.set_active_bulk_attribute_name();
            prodigyProduct.show_available_variants_bulk(active_bulk_attribute);
            prodigyProduct.set_variant_modifier(active_bulk_attribute);
            if (this.is_active_logo_bulk) {
                $(document).trigger('enable-multiple-quantity');
            }
        },

        get_bulk_variant_data: function (variant, current_options) {
            let self = this;
            let post_data = {
                action: "prodigy-public-get-variant-multiple-data",
                post_id: $("#product_id").val(),
                variants: variant,
                bulk_attributes: current_options,
                nonce: settings.nonce
            };

            clearTimeout(self.timeoutMultipleDataId);
            self.timeoutMultipleDataId = setTimeout(
                function () {
                    $.ajax({
                            type: "post",
                            data: post_data,
                            dataType: "json",
                            url: ajax_url,
                            error: function (xhr, status, error) {
                            },
                            success: function (response) {
                                self.set_variant_bulk_info(response);
                                if (product_logo_management_object.is_logo() && !self.is_active_logo_bulk) {
                                    self.set_bulk_data();
                                }
                            }
                        }
                    );
                },
                500
            );
        },

        set_bulk_data: function () {
            let self = this;
            let total_quantity = 0;
            let attribute_name = '';
            let bulkOptions = [];
            let selected_variant = prodigyProduct.get_selected_variant();

            $(self.bulk_container_element).each(function (e) {
                let is_visible = $(this).is(':visible');
                let variant = '';
                if (is_visible) {
                    $(this).find(self.input_bulk_quantity_element).each(function (e) {
                        let bulk_input_value = parseInt($(this).val());
                        let cleanedString;
                        if (!isNaN(bulk_input_value)) {
                            total_quantity += bulk_input_value;
                            attribute_name = $(this).data('option');
                            let found = false;
                            if (selected_variant instanceof Array) {
                                found = selected_variant.includes(attribute_name);
                            }

                            variant = (selected_variant instanceof Array) ? selected_variant.join("&") : selected_variant;
                            if (!found) {
                                cleanedString = variant;
                                if (selected_variant.length === 1) {
                                    cleanedString = variant.replace(/&/g, "");
                                }
                                variant = attribute_name + '&' + cleanedString;
                            }

                            let obj = {
                                variant: variant.replace(/&$/, ""),
                                quantity: bulk_input_value
                            };
                            selected_variant = variant.replace(attribute_name, "");
                            bulkOptions.push(obj);
                        }
                    });

                    $(self.total_quantity_element).text(total_quantity);
                    self.get_bulk_variants_data(total_quantity, bulkOptions);
                }
            });
        },


        get_bulk_variants_data: function (quantity, selected_variant_options) {
            this.bulkVariants = selected_variant_options;
            this.bulkTotalQuantity = quantity;
            let logo_id = product_logo_management_object.get_logo_id();
            prodigyProduct.get_variant_data(selected_variant_options, quantity, logo_id, null, true, false);
        },

        set_variant_bulk_info: function (response) {
            let self = this;
            $.each(
                response.data,
                function (key, value) {
                    self.set_bulk_price_modifier(key, value);
                    self.set_bulk_stock_info(key, value);
                    let $body_option_element = $('.prodigy-bulk-input-js[data-option=' + key + ']').parent();
                    if (typeof value.remote_variant_id !== "undefined" && value.remote_variant_id === null) {
                        if (typeof $body_option_element !== "undefined") {
                            self.set_hide_hidden_variant(key, $body_option_element);
                        }
                    } else {
                        self.set_show_restored_variant(key, $body_option_element);
                    }
                }
            );
        },

        set_show_restored_variant: function (option_value_name, $body_option_element) {
            if ($body_option_element.hasClass('prodigy-bulk__table-cell-body-hidden-variant')) {
                $body_option_element.removeClass('prodigy-bulk__table-cell-body-hidden-variant');
            }
        },

        set_hide_hidden_variant: function (option_value_name, $body_option_element) {
            $body_option_element.addClass('prodigy-bulk__table-cell-body-hidden-variant');
        },

        set_bulk_stock_info: function (key, value) {
            let key_field = key.replace(/\s/g, "_");
            if (typeof value.inventory !== "undefined" && value.inventory.attributes) {
                if (
                    value.inventory.attributes['manage-stock'] &&
                    value.inventory.attributes['count'] !== null
                ) {
                    $(this.bulk_stock_status + key_field).text('In stock: ');
                    if (value.inventory.attributes['count'] !== null) {
                        $(this.bulk_stock_qty + key_field).text(value.inventory.attributes['count']);
                    }
                } else {
                    $(this.bulk_stock_status + key_field).text(this._stock_status_mapper[value.inventory.attributes['stock']]);
                }
            }
        },


        set_bulk_price_modifier: function (key, value) {
            if (
                value.is_tiered_price &&
                value.attributes &&
                typeof value.attributes['price-quantity-modifier'] !== "undefined" &&
                parseFloat(value.attributes['price-quantity-modifier']) > 0
            ) {
                $(this.bulk_price_modifier_element + key).show();
                $(this.bulk_price_modifier_element + key).text('+ $' + parseFloat(value.attributes['price-quantity-modifier']));
            } else {
                $(this.bulk_price_modifier_element + key).hide();
            }
        },

		set_bulk_variants_data: function () {
			let self = this;
			$(document).on("input", '.prodigy-bulk-input-js', function (e) {
				$(this).val($.trim($(this).val()));
				self.set_bulk_data();
			});
		},
    }
    window.prodigyProductBulk = prodigy_product_bulk;
})(jQuery, window);

jQuery(document).ready(function ($) {
    window.prodigyProductBulk.init();

    // Fix for the error: 'Blocked aria-hidden on an element because its descendant retained focus.'
    const MODAL = '#disableBulkModal';
    $(document).on('show.bs.modal', MODAL, function (e) {
      this.__opener = e.relatedTarget || document.activeElement || null;
    });

    $(document).on('hide.bs.modal', MODAL, function () {
      const modal = this;
      if (modal.contains(document.activeElement)) {
        const fallback =
          (modal.__opener && document.contains(modal.__opener) && modal.__opener) ||
          document.body;
        fallback.focus();
      }
    });

    $(document).on('hidden.bs.modal', MODAL, function () {
      if (this.__opener && document.contains(this.__opener) && document.activeElement === document.body) {
        this.__opener.focus();
      }
      this.__opener = null;
    });
});
